import React from "react";
import { PostmatchTableColumnsHeaderProps } from "./postmatch-table-columns-header.types";
import styles from "../postmatch-table-columns/postmatch-table-columns.module.css";

export const PostmatchTableColumnsHeader = ({
  text,
  className = styles.header,
}: PostmatchTableColumnsHeaderProps) => <div className={className}>{text}</div>;
